import { Navigate, Outlet } from 'react-router';
import { useAccount } from '@core/utils/auth';
import { canManageCompany } from '@core/utils/auth/companyRole';
import { PATHS } from '@core/routes';

export function RequireAdmin() {
  const { user } = useAccount();

  if (!canManageCompany(user?.role)) {
    return <Navigate to={PATHS.home} replace />;
  }

  return <Outlet />;
}
